<template>
  <div class="content">
    <h3 ref="pageHeader"   class="pageHeader">组织结构管理</h3>
    <div>
    </div>
    <div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
          <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.user" placeholder="请输入设备名称"></el-input>
        </el-form-item> -->
          <template v-if="$store.state.userInfo&&($store.state.userInfo.number=='xsadmin'||$store.state.userInfo.number=='admin')">
            <el-form-item>
              <el-button type="primary" @click="syncOrgan"> 同步组织结构</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="syncUser"> 同步用户</el-button>
            </el-form-item>
          </template>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载组织结构导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="getTree" :action="action" :params="params" btnTitle="导入组织结构"></Importt>
        </el-form-item>
        </el-form>
      </div>
      <div style="display:flex;">
        <div style="padding:20px;background:#fff;min-width:500px;min-height:200px;width: 80%;">
          <el-tree :data="data" node-key="id" :expand-on-click-node="true" :default-expanded-keys="defaultKey" :props="defaultProps">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="() => append(data)"></el-button>
                <el-button type="warning" v-if="data.id" size="mini" icon="el-icon-edit" circle @click="() => edit(data)"></el-button>
                <el-button type="danger" v-if="data.id" icon="el-icon-delete" size="mini" @click="() => remove(node, data)" circle></el-button>
              </span>
            </span>
          </el-tree>
        </div>
        <!-- <div style="flex:1;padding:20px;background:#fff;overflow: auto;">
          <custom-table :data="tableData" ref="table" border style="width: 100%">
            <custom-table-column fixed prop="name" label="姓名" width="120">
            </custom-table-column>
            <custom-table-column fixed prop="number" label="工号" width="180">
            </custom-table-column>
            <custom-table-column prop="gender" label="性别" width="80">
            </custom-table-column>
            <custom-table-column prop="phone" label="联系方式" width="150">
            </custom-table-column>
            <custom-table-column prop="structure" label="组织结构">
            </custom-table-column>
            <custom-table-column prop="posts" label="职位" width="120">
            </custom-table-column>

          </custom-table>
          <div class="pageLine">
            <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
          </div>
        </div> -->

      </div>
      <el-dialog :close-on-click-modal="false" :title="addDialogTitle" :visible.sync="addDialogVisible" width="500px" @before-close="hanleClossee">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="组织结构名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入组织结构名称" style="width:266px;"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
            <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
            <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
        <span>{{delText}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteOrgan">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import PageLine from '@/components/page.vue';
// import { mixinList } from '@/assets/js/mixin/list';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  name: 'trainingRoom',
  mixins: [mixinImport],
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        date: '',
      },
      delText:'是否删除',
      defaultKey: ['1'],
      type: 'add',
      dialogVisible:false,
      addDialogTitle: '新增',
      addDialogVisible: false,
      params: {},
      centerDialogVisible: false,
      total: 40,
      tableData: [],
      action: `${this.$store.state.baseUrl}admin/structure/import`,
      downloadUrl: 'template/zzjgdr.xlsx',
      downloadName: '组织结构导入模板.xlsx',
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      ruleForm: {
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入组织结构名称', trigger: 'blur' }],
      },
      id: 1000,
      data: [],
      node: '',
      nodeData: '',
      delid:'是否删除',
      downloadUrl: 'template/组织结构导入模版.xlsx',
      downloadName: '组织结构导入模版.xlsx',
    };
  },
  components: {
    // PageLine,
  },
  created() {
    this.action = `${this.baseUrlt}api/school/structure/import`;
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
      this.handleQuery();
    },
    syncOrgan() {
      this.confirmBox('warning', `此操作将同步实习系统的组织结构数据，是否继续`, {}, this.setStatus);
    },
    syncUser() {
      this.confirmBox('warning', `此操作将同步实习系统的用户数据，是否继续`, {}, this.setUser);
    },
    async setUser(params) {
      let res = await this.$api.instance.interfaceServer(`api/sync/user`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '同步成功！',
        });
        // this.getTree();
      }
    },
    confirmBox(type, title, params, $fun) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type,
      })
        .then(() => {
          $fun(params)
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    handleDelet(id) {
      this.delid = id
      this.dialogVisible = true
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/structure/xixunsync`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '同步成功！',
        });
        this.getTree();
      }
    },
    async deleteOrgan() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteOrgan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getTree();
        // const parent = this.node.parent;
        // const children = parent.data.sub || parent.data;
        // const index = children.findIndex((d) => d.id === this.nodeData.id);
        // children.splice(index, 1);
        // this.dialogVisible = false;
        // this.getList();
      }
    },
    hanleClossee() {
      this.addDialogVisible = false;
      console.log(111);
    },
    handleQuery() {
      this.getTree();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      // let params = {
      //   current: this.$refs.pageChild.page,
      //   pageSize: this.$refs.pageChild.size,
      // };
      // if (this.formInline.training_no) {
      //   params.training_no = this.formInline.training_no;
      // }
      // if (this.formInline.status) {
      //   params.status = this.formInline.status;
      // }
      // let res = await this.$api.query.getTeachers(params);
      // if (res.code == 0 && res.data) {
      //   this.tableData = res.data.data;
      //   this.total = res.data.total;
      // }
    },
    async getTree() {
      this.data = [];
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.data = res.data.map((item) => {
          item.id = '1';
          return item;
        });
      }
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrEditNode();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    clearForm() {
      this.getTree();
      this.addDialogVisible = false;
      this.ruleForm.name = '';
    },
    async addOrEditNode() {
      if (this.type == 'add') {
        let res = await this.$api.instance.addTreeNode(this.ruleForm);
        if (res.code == 0 && res.data) {
          this.$message.success('添加成功！');
          this.clearForm();
        }
      } else {
        let res = await this.$api.instance.editTreeNode(this.ruleForm);
        if (res.code == 0 && res.data) {
          this.$message.success('修改成功！');
          this.clearForm();
        }
      }
    },
    append(data) {
      this.type = 'add';
      this.addDialogTitle = '新增';
      if (data.id) {
        this.ruleForm.parent_id = data.id;
      }
      // console.log(data)
      this.addDialogVisible = true;
      // const newChild = { id: this.id++, name: 'New node', sub: [] };
      // if (!data.sub) {
      //   this.$set(data, 'sub', []);
      // }
      // data.sub.push(newChild);
    },
    edit(data) {
      this.type = 'edit';
      this.addDialogTitle = '编辑';
      if (data.id) {
        this.ruleForm.id = data.id;
        this.ruleForm.name = data.name;
      }
      this.addDialogVisible = true;
    },
    remove(node, data) {
      // this.node = node;
      // this.nodeData = data;
      this.handleDelet(data.id);
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button size="mini" type="primary" on-click={() => this.append(data)}>
              +
            </el-button>
            <el-button size="mini" type="danger" on-click={() => this.remove(node, data)}>
              -
            </el-button>
          </span>
        </span>
      );
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: 132px;
}
/deep/.el-tree-node__content {
  padding: 4px 0;
}
/deep/.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  width: calc(100% - 34px);
  border-bottom: 1px dashed #cdd1d3;
  padding-bottom: 4px;
  > span:nth-child(2) {
    margin-left: 20px;
    width: 100px;
  }
  > span:nth-child(1) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }
}
/deep/ .el-tree-node__content {
  height: auto;
}
/deep/.el-button--mini {
  font-size: 14px;
  font-weight: normal;
  padding: 6px 6px;
}
</style>
